import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Spinner } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { Tooltip } from "bootstrap";
import { collection, addDoc } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { Link } from "react-router-dom";
import "../index.css";
import events from "../../data/events.json";

// Component for events sign up form.
export default function EventSignUpForm({
  eventName,
  bannerImage,
  firestorePath,
  BGImage,
  rsvp = false,
  firebaseStoragePath,
}) {
  console.log("🔥 Firestore path passed to form:", firestorePath);

  const [colleges, setColleges] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedCollege, setSelectedCollege] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isWARegistered, setIsWARegistered] = useState(true);
  const [subscribe, setSubscribe] = useState(true);

  // Loader
  const [isLoading, setIsLoading] = useState(false);

  // Add state for Proof of Payment file
  const [proofOfPaymentFile, setProofOfPaymentFile] = useState(null);
  const [proofOfPaymentError, setProofOfPaymentError] = useState("");

  // Modal
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // During h-1 of event at 11:59 PM, we want to close the registration,
  // and show modal indicating to register OTS.
  const [closingDate, setClosingDate] = useState(""); // Closing time for registration
  const [showOTSModal, setShowOTSModal] = useState(false); // Modal state for OTS registration

  // const seattleColleges = [
  //   { name: "University of Washington" },
  //   { name: "University of Washington Tacoma" },
  //   { name: "University of Washington Bothell" },
  //   { name: "Shoreline Community College" },
  //   { name: "Edmonds Community College" },
  //   { name: "Bellevue College" },
  //   { name: "North Seattle College" },
  //   { name: "Cascadia College" },
  //   { name: "Northwest University" },
  //   { name: "Seattle University" },
  //   { name: "Green River College" },
  //   { name: "Seattle Pacific University" },
  //   { name: "Seattle Central College" },
  //   { name: "Whatcom Community College" },
  // ];

  // Function to handle scrolling and escape key
  useEffect(() => {
    if (showSuccessModal || showErrorModal) {
      document.body.style.overflow = "hidden";

      const handleEsc = (event) => {
        if (event.key === "Escape") {
          setShowSuccessModal(false);
          setShowErrorModal(false);
        }
      };
      window.addEventListener("keydown", handleEsc);

      return () => {
        document.body.style.overflow = "auto";
        window.removeEventListener("keydown", handleEsc);
      };
    }
  }, [showSuccessModal, showErrorModal]);

  const handleOutsideClick = (e) => {
    if (e.target.id === "modal-overlay") {
      setShowSuccessModal(false);
      setShowErrorModal(false);
    }
  };

  // Handle modal transitions
  useEffect(() => {
    if (showSuccessModal || showErrorModal) {
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
    }
  }, [showSuccessModal, showErrorModal]);

  const closeModal = () => {
    setIsVisible(false);
    setShowSuccessModal(false);
    setShowErrorModal(false);
  };

  // Initialize tooltips
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl);
    });
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm();

  // const renderCollegeListTemp = (name) => {
  //   if (name) {
  //     const filteredColleges = seattleColleges.filter((college) =>
  //       college.name.toLowerCase().includes(name.toLowerCase())
  //     );

  //     if (filteredColleges.length > 0) {
  //       setColleges(filteredColleges);
  //       setShowSuggestions(true);
  //       setSelectedCollege(name);
  //     } else {
  //       setColleges([{ name }]);
  //       setShowSuggestions(true);
  //       setSelectedCollege(name);
  //     }
  //   } else {
  //     setColleges([]);
  //     setShowSuggestions(false);
  //     setSelectedCollege("");
  //   }
  // };

  useEffect(() => {
    if (showSuccessModal || showErrorModal || showOTSModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showSuccessModal, showErrorModal, showOTSModal]);

  const handlePhoneNumber = (e) => {
    setPhoneNumber(e);
    setValue("phoneNumber", e);
    clearErrors("phoneNumber");
  };

  const handleProofOfPaymentFile = (e) => {
    const file = e.target.files[0];
    setProofOfPaymentFile(file);
    clearErrors("proofOfPayment");
    console.log("proof of payment file", file);
  };

  // TODO: implement update to spreadsheets in real time using Google Sheets API.
  const onSubmit = async (data) => {
    setIsLoading(true);

    let proofOfPaymentURL = "";

    if (rsvp && proofOfPaymentFile) {
      // Only upload if RSVP is true and file is selected
      const storageRef = ref(
        storage,
        `${firebaseStoragePath}/proofs-of-payment/${proofOfPaymentFile.name}`,
      );
      const uploadResult = await uploadBytes(storageRef, proofOfPaymentFile);
      proofOfPaymentURL = await getDownloadURL(uploadResult.ref);
    }

    const baseData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      major: data.major,
      batch: data.batch,
      proofOfPayment: proofOfPaymentURL,
      additionalQuestion: data.additionalQuestion,
      isWARegistered: isWARegistered,
      subscribe: subscribe,
      timestamp: new Date().toISOString(),
      firestorePath,
    };

    // Add these fields only for seattle101
    if (firestorePath === "2025/seattle101/events_registration") {
      baseData.cityOfOrigin = data.cityOfOrigin;
      baseData.incomingSchool = data.incomingSchool;
    }

    const formData = baseData;

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowSuccessModal(true);
      } else {
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error submitting registration: ", error);
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSelectCollege = (collegeName) => {
  //   setSelectedCollege(collegeName);
  //   setSearchInput(collegeName);
  //   setShowSuggestions(false);
  // };

  // Function to check if registration should be closed based on the event's date
  const checkRegistrationStatus = () => {
    // console.log("All events:", events);
    const uncompletedEvent = events.find((event) => event.completed === false);
    const date = uncompletedEvent.date;
    setClosingDate(date);

    // console.log("date", date);

    // if (event) {
    //   console.log("event.date", event.date);
    //   // Parse event date
    //   const [eventMonth, eventDay, eventYear] = event.date.split("/");
    //   const eventDate = new Date(
    //     `${eventYear}-${eventMonth}-${eventDay}T00:00:00`
    //   );

    //   // Subtract one day from event date
    //   const oneDayBeforeEvent = new Date(eventDate);
    //   oneDayBeforeEvent.setDate(oneDayBeforeEvent.getDate() - 1);

    //   // Format the current date to MM/DD/YYYY
    //   const currentDateUnformatted = new Date(); // Gets the current date and time
    //   const currentDate = `${(currentDateUnformatted.getMonth() + 1)
    //     .toString()
    //     .padStart(2, "0")}/${currentDateUnformatted
    //     .getDate()
    //     .toString()
    //     .padStart(2, "0")}/${currentDateUnformatted.getFullYear()}`;

    //   // Format one day before the event date to MM/DD/YYYY
    //   const oneDayBefore = `${(oneDayBeforeEvent.getMonth() + 1)
    //     .toString()
    //     .padStart(2, "0")}/${oneDayBeforeEvent
    //     .getDate()
    //     .toString()
    //     .padStart(2, "0")}/${oneDayBeforeEvent.getFullYear()}`;

    //   const currentHours = currentDateUnformatted.getHours();
    //   const currentMinutes = currentDateUnformatted.getMinutes();

    //   // Check if the current date is one day before the event date
    //   if (currentDate === oneDayBefore) {
    //     // Check if current time is 11:59 PM or later
    //     if (currentHours === 23 && currentMinutes >= 59) {
    //       setShowOTSModal(true); // Trigger the OTS modal
    //     }
    //   } else if (currentDate > oneDayBefore) {
    //     // If current date is after one day before the event, show OTS modal
    //     setShowOTSModal(true);
    //   } else {
    //     // If the current date is before one day before the event, do not show OTS modal
    //     setShowOTSModal(true);
    //   }
    // } else {
    //   console.log("event not found in events.json");
    // }
  };
  // Check registration status when component mounts or eventsSet changes
  useEffect(() => {
    checkRegistrationStatus();
  }, []);

  const OTSModal = (
    <div
      id="modal-overlay"
      className={`fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
        showOTSModal ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="bg-white w-11/12 sm:w-96 rounded-xl shadow-lg p-6 transform transition-all duration-300">
        <h2 className="text-center text-xl font-bold text-gray-900 mb-2">
          Registration Closed
        </h2>
        <p className="text-center text-gray-600 text-sm">
          Registration for {eventName} is now closed. Please register{" "}
          <span className="font-bold">on-site</span>.
        </p>
        <div className="flex justify-center mt-4">
          <Link
            to="/"
            className="bg-[#941A1A] hover:bg-[#7a1414] text-white py-2 px-4 rounded-lg w-full text-center transition-all flex justify-center items-center gap-2"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {showOTSModal && OTSModal}
      <div
        className="h-96 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/${BGImage}')`,
        }}
      />
      <div className="flex justify-center items-center h-full bg-white bg-opacity-60 mb-36">
        <div className="bg-white rounded-lg w-10/12 md:w-2/5 mt-[-240px] shadow-md">
          <img
            src={`/images/${bannerImage}`}
            alt="event poster"
            className="mb-2 object-fill h-42 rounded-t-lg"
          />
          <div className="p-4 overflow-hidden pb-8 mb-8">
            <h1 className="text-center mb-4 text-lg font-bold">
              {eventName} Registration
            </h1>

            <form onSubmit={handleSubmit(onSubmit)}>
              {/* First Name */}
              <div className="mb-3 top-0">
                <label htmlFor="firstName" className="form-label">
                  <div className="flex flex-row gap-1">
                    First Name <div className="text-red-500"> *</div>
                  </div>
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  autoComplete="first-name"
                  placeholder="Enter your first name"
                  className="form-control"
                  {...register("firstName", {
                    required: "First Name is required.",
                  })}
                />
                {errors.firstName && (
                  <div className="text-danger">{errors.firstName.message}</div>
                )}
              </div>

              {/* Last Name */}
              <div className="mb-3">
                <label htmlFor="lastName" className="form-label">
                  <div className="flex flex-row gap-1">
                    Last Name <div className="text-red-500"> *</div>
                  </div>
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  className="form-control"
                  placeholder="Enter your last name"
                  autoComplete="last-name"
                  {...register("lastName", {
                    required: "Last Name is required.",
                  })}
                />
                {errors.lastName && (
                  <div className="text-danger">{errors.lastName.message}</div>
                )}
              </div>

              {/* Email */}
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  <div className="flex flex-row gap-1">
                    Email
                    <div className="text-red-500"> *</div>
                  </div>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className="form-control"
                  placeholder="Enter your email"
                  {...register("email", { required: "Email is required." })}
                />
                {errors.email && (
                  <div className="text-danger">{errors.email.message}</div>
                )}
              </div>

              {/* University Search and Suggest */}
              {/* <div className="mb-3">
                <label htmlFor="selectedCollege" className="form-label">
                  University / College
                </label>
                <input
                  id="selectedCollege"
                  name="selectedCollege"
                  type="text"
                  className="form-control"
                  placeholder="Enter your University / College"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                    renderCollegeListTemp(e.target.value);
                  }}
                />
                {showSuggestions && !isLoading && (
                  <ul
                    className="list-group mt-2"
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {colleges.map((college, index) => (
                      <li
                        key={index}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSelectCollege(college.name)}
                        style={{ cursor: "pointer" }}
                      >
                        {college.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div> */}

              {/* Phone Number */}
              <div className="mb-3">
                <label htmlFor="phoneNumber" className="form-label">
                  <div className="flex flex-row gap-1">
                    Phone Number
                    <div className="text-red-500"> *</div>
                  </div>
                </label>
                <PhoneInput
                  id="phoneNumber"
                  name="phoneNumber"
                  className="form-control"
                  placeholder="Enter your phone number"
                  international
                  defaultCountry="US"
                  value={phoneNumber}
                  {...register("phoneNumber", {
                    required: "Phone Number is required",
                    validate: (value) => {
                      return (
                        isValidPhoneNumber(value) ||
                        "Phone Number should be valid and is required."
                      );
                    },
                  })}
                  onChange={(value) => {
                    handlePhoneNumber(value);
                  }}
                />
                <small>
                  Enter a <i className="fa fa-whatsapp"></i>
                  <a
                    href="https://whatsapp.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    WhatsApp
                  </a>{" "}
                  registered number to opt for event reminders.
                </small>
                {errors.phoneNumber && (
                  <div className="text-danger">
                    {errors.phoneNumber.message}
                  </div>
                )}
              </div>

              {/* Major */}
              <div className="mb-3">
                <label htmlFor="major" className="form-label">
                  <div className="flex flex-row gap-1">
                    Major / Intended Major{" "}
                    <div className="text-red-500"> *</div>
                  </div>
                </label>
                <input
                  id="major"
                  name="major"
                  className="form-control"
                  placeholder="Enter your major"
                  autoComplete="major"
                  {...register("major", {
                    required: "Major is required.",
                  })}
                />
                {errors.major && (
                  <div className="text-danger">{errors.major.message}</div>
                )}
              </div>

              {/* {isSeattle101 && (
                <> */}
              {/* City of Origin (Seattle 101 only) */}
              {/* <div className="mb-3">
                    <label htmlFor="city" className="form-label">
                      <div className="flex flex-row gap-1">
                        City of Origin <div className="text-red-500"> *</div>
                      </div>
                    </label>
                    <input
                      id="city"
                      name="city"
                      className="form-control"
                      placeholder="Enter your city of origin"
                      autoComplete="city"
                      {...register("cityOfOrigin", {
                        required: isSeattle101
                          ? "City of Origin is required."
                          : false,
                      })}
                    />
                    {errors.cityOfOrigin && (
                      <div className="text-danger">
                        {errors.cityOfOrigin.message}
                      </div>
                    )}
                  </div> */}

              {/* Incoming School (Seattle 101 only) */}
              {/* <div className="mb-3">
                    <label htmlFor="incomingSchool" className="form-label">
                      <div className="flex flex-row gap-1">
                        Incoming School / Institution{" "}
                        <div className="text-red-500"> *</div>
                      </div>
                    </label>
                    <input
                      id="incomingSchool"
                      name="incomingSchool"
                      className="form-control"
                      placeholder="Enter your incoming school or institution"
                      autoComplete="incomingSchool"
                      {...register("incomingSchool", {
                        required: isSeattle101
                          ? "Incoming School / Institution is required."
                          : false,
                      })}
                    />
                    {errors.incomingSchool && (
                      <div className="text-danger">
                        {errors.incomingSchool.message}
                      </div>
                    )}
                  </div> */}
              {/* </>
              )} */}

              {/* Batch */}
              <div className="mb-3">
                <label htmlFor="batch" className="form-label">
                  <div className="flex flex-row gap-1">
                    Batch <div className="text-red-500"> *</div>
                  </div>
                </label>
                <input
                  id="batch"
                  name="batch"
                  className="form-control"
                  placeholder="e.g., Freshman, Sophomore, Junior"
                  autoComplete="batch"
                  {...register("batch", {
                    required: "Batch is required.",
                  })}
                />
                {errors.batch && (
                  <div className="text-danger">{errors.batch.message}</div>
                )}
              </div>

              {/* Proof of Payment */}
              {rsvp && (
                <div className="mb-3">
                  <label htmlFor="proofOfPayment" className="form-label">
                    Proof of Payment <span className="text-red-500"> *</span>
                  </label>
                  <input
                    id="proofOfPayment"
                    name="proofOfPayment"
                    type="file"
                    accept=".jpg,.jpeg,.png,.pdf"
                    className="form-control"
                    {...register("proofOfPayment", {
                      required: "Proof of payment is required.",
                    })}
                    onChange={(value) => {
                      handleProofOfPaymentFile(value);
                    }}
                  />
                  {proofOfPaymentError && (
                    <div className="text-danger">{proofOfPaymentError}</div>
                  )}
                  {errors.proofOfPayment && (
                    <div className="text-danger">
                      {errors.proofOfPayment.message}
                    </div>
                  )}
                  <small className="form-text text-muted">
                    Please upload a screenshot of your payment. Payments can be
                    sent via:
                    <br />
                    <div style={{ marginLeft: "20px" }}>
                      Zelle: nem409@uw.edu
                    </div>
                    When making the payment, please include your registered name
                    in the note section.
                    <br />
                    $3 / person <br />
                  </small>
                </div>
              )}

              {/* Additional Question */}
              <div className="mb-3">
                <label htmlFor="additionalQuestion" className="form-label">
                  Additional Question (Optional)
                </label>
                <textarea
                  id="additionalQuestion"
                  name="additionalQuestion"
                  className="form-control"
                  rows="4"
                  placeholder="Ask us anything or share additional information..."
                  {...register("additionalQuestion")}
                />
                {errors.additionalQuestion && (
                  <div className="text-danger">
                    {errors.additionalQuestion.message}
                  </div>
                )}
              </div>

              {/* Boolean Whatsapp */}
              <div className="flex flex-row gap-2">
                <label htmlFor="isWARegistered" className="form-label">
                  Whatsapp registered number?
                </label>
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Check if your number is WhatsApp registered"
                >
                  <input
                    type="checkbox"
                    id="isWARegistered"
                    className="form-check-input"
                    checked={isWARegistered}
                    onChange={(e) => setIsWARegistered(e.target.checked)}
                  />
                </div>
              </div>

              {/* Boolean Subscribe Newsletter */}
              <div className="mb-3 flex flex-row gap-2">
                <label htmlFor="subscribe" className="form-label">
                  Subscribe to our newsletter?
                </label>

                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Subscribe to get updates about ISAUW, and much more!"
                >
                  <input
                    type="checkbox"
                    id="subscribe"
                    className="form-check-input"
                    checked={subscribe}
                    onChange={(e) => setSubscribe(e.target.checked)}
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`w-full py-2 px-4 bg-[#941A1A] hover:bg-[#7a1414] text-white font-semibold rounded-lg shadow-md  focus:outline-none focus:ring-2 focus:ring-[#941A1A] focus:ring-opacity-75 transition duration-300 ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mr-2"
                    />
                    Registering...
                  </>
                ) : (
                  "Register"
                )}
              </button>

              {/* Success Modal */}
              {showSuccessModal && (
                <div
                  id="modal-overlay"
                  onClick={handleOutsideClick}
                  className={`fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                    isVisible ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <div
                    className={`bg-white w-11/12 sm:w-96 rounded-xl shadow-lg p-6 transform transition-all duration-300 ${
                      isVisible ? "scale-100 opacity-100" : "scale-90 opacity-0"
                    }`}
                  >
                    <div className="flex justify-end">
                      <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={closeModal}
                      >
                        ✕
                      </button>
                    </div>
                    <div className="flex justify-center items-center mb-4">
                      <div className="bg-[#107614] rounded-full p-2">
                        <svg
                          className="h-8 w-8 text-white"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                            className="tick"
                          />
                        </svg>
                      </div>
                    </div>
                    <h2 className="text-center text-xl font-bold text-gray-900 mb-2">
                      You're All Set!
                    </h2>
                    <p className="text-center text-gray-600 text-sm">
                      Your registration has been successfully submitted! Thank
                      you and see you on {eventName}!
                    </p>
                    <div className="flex flex-row gap-2 mt-4">
                      <Link
                        to="/"
                        className="bg-[#107614] text-white py-2 px-4 rounded-lg w-full text-center hover:bg-[#095F0C] transition-all flex justify-center items-center gap-2"
                      >
                        See you there!
                      </Link>
                    </div>
                  </div>
                </div>
              )}

              {/* Error Modal */}
              {showErrorModal && (
                <div
                  id="modal-overlay"
                  onClick={handleOutsideClick}
                  className={`fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                    isVisible ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <div
                    className={`bg-white w-11/12 sm:w-96 rounded-xl shadow-lg p-6 transform transition-all duration-300 ${
                      isVisible ? "scale-100 opacity-100" : "scale-90 opacity-0"
                    }`}
                  >
                    <div className="flex justify-end">
                      <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={closeModal}
                      >
                        ✕
                      </button>
                    </div>
                    <div className="flex justify-center items-center mb-4">
                      <div className="bg-red-500 rounded-full p-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-8 w-8 text-white"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                    <h2 className="text-center text-xl font-bold text-gray-900 mb-2">
                      Error
                    </h2>
                    <p className="text-center text-gray-600 text-sm">
                      There was an error submitting your registration. Please
                      try again.
                    </p>
                    <div className="flex justify-center mt-4">
                      <button
                        className="bg-red-500 text-white py-2 px-4 rounded-lg w-full hover:bg-red-700 transition-all"
                        onClick={closeModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* End modal */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
